const S=(whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps)=>({whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps}); const N=(id,title,when,description)=>({id,title,...(description?{description}:{}),when});
export const zh={
'imaging-diagnostics':{
before:S('检查前请仔细阅读预约说明。您可能需要禁食、调整某些药物的服用时间、提前到达或先验血。请告知团队您是否有过敏、怀孕或体内植入物。也请说明任何行动、沟通或其他支持需求。','不同检查需要不同准备，目的是让检查更安全并获得有用信息。','团队会确认您的身份、所申请的检查、安全信息，以及是否需要特别准备或合理调整。','所有诊断检查并没有统一的准备规则。请遵循您这次具体预约的说明。',[
N('attend-test','按计划参加检查','当准备说明清楚且检查可以进行时'),
N('clarify-preparation','先确认准备或安全信息','如果说明不清楚或自申请检查后情况有变化','团队可能需要核对药物、过敏、怀孕、植入物、肾功能或其他问题。'),
N('rearrange-test','必要时改期或更换检查','如果当天继续原检查并不安全或不能获得有用结果')
]),
visit:S('就诊时，您可能进行采血、X光、CT、MRI、超声或其他诊断或功能检查。有些检查会使用留置针、造影剂或监测。','检查用于收集信息，帮助临床团队了解症状、监测已有疾病、计划治疗或判断治疗效果。','执行检查的工作人员会确认检查安全进行，并确保图像、测量数据或样本质量足以供后续分析。','执行检查的人不一定是最终出报告或向您解释结果的人。',[
N('finish-and-leave','完成检查并离开科室','如果检查完成且不需要继续观察'),
N('short-observation','短时间留观','如果检查、造影剂、药物或您的情况需要短暂监测'),
N('additional-test','进行额外或不同的检查','如果需要另一项检查才能回答临床问题')
]),
results:S('检查后，图像、测量数据或样本可能需要审核并形成正式报告。结果通常会发送给申请检查的医生或团队。他们可以结合您的其他临床信息解释结果的含义。','结果可能需要专科人员解释，并与症状、既往检查或其他资料一起判断。','诊断科专业人员会审核检查，申请该检查的团队再决定是否需要进一步检查、治疗、监测或随访。','不同检查出结果时间差异很大。单独一个结果并不总能给出诊断；如果超过告知时间仍未收到消息，请使用服务提供的联系方式查询。',[
N('routine-result','通过计划中的方式收到结果','如果结果可以在常规预约或服务中讨论'),
N('more-tests','进一步检查或专科评估','如果结果仍不能完全回答临床问题'),
N('treatment-or-follow-up','进入治疗、监测或随访','如果结果已经足够帮助团队与您确定下一步')
])},
radiotherapy:{
planning:S('放疗开始前，肿瘤科团队会解释为什么建议治疗、治疗部位以及预期收益和副作用。您通常会有一次治疗计划预约。预约可能包括CT扫描和仔细定位。有些人需要定制面罩、模具或其他支撑，以帮助在治疗期间保持相同姿势。','放疗需要精确对准目标区域，同时尽可能减少周围正常组织受到的辐射。','肿瘤和放疗团队会结合影像和临床资料制定个人治疗计划，并确认定位和准备要求。','计划方式取决于治疗部位和目标。并不是每个人都需要固定面罩、造影剂、特殊饮食或相同次数的治疗。',[
N('start-radiotherapy','开始计划中的放疗疗程','当计划完成并经过检查确认后'),
N('more-planning','进行额外计划或检查','如果开始治疗前还需要其他扫描、不同定位或更多信息'),
N('change-treatment-plan','复查或调整治疗计划','如果开始前健康状况、影像或治疗重点发生变化')
]),
treatment:S('每次治疗时，治疗放射技师会帮助您保持计划好的姿势，并用放疗设备对目标区域进行治疗。实际照射通常时间不长，但定位和核对可能需要更久。','放疗常分多次进行，以便安全完成计划中的总治疗。','放射技师每次都会核对身份、姿势和治疗信息，团队也会监测副作用和支持需要。','副作用取决于治疗部位，并可能在疗程中逐渐出现或加重。如果错过预约，请尽快联系放疗团队了解下一步。',[
N('continue-course','继续计划中的疗程','如果治疗按计划进行且副作用可以控制'),
N('support-review','因副作用或支持需要增加复查','如果症状、营养、皮肤、疼痛、疲劳或其他问题需要更多帮助'),
N('complete-course','完成放疗并进入随访','当计划疗程结束或团队同意停止治疗时')
]),
after:S('最后一次放疗后，一些副作用可能需要时间才会缓解，也可能短暂加重。团队应说明恢复、需要报告的症状以及随访安排。','放疗在最后一次治疗后仍会产生生物学作用，因此恢复和疗效评估通常不会立即完成。','团队会帮助处理短期副作用，并计划如何评估治疗效果。','恢复和随访时间取决于治疗部位、目标和其他抗癌治疗。如症状恶化，请按您的放疗团队提供的紧急联系方式处理。',[
N('recover-and-monitor','恢复并监测症状','如果治疗已经完成且副作用可按现有计划管理'),
N('planned-follow-up','参加计划中的肿瘤随访','当团队需要复查恢复、治疗反应或下一阶段护理时'),
N('earlier-review','必要时提前联系团队','如果症状加重、出现新问题或团队曾建议这些变化需要快速评估')
])},
chemotherapy:{
planning:S('在化疗或其他全身抗肿瘤治疗开始前，团队会解释建议使用的药物、治疗目标、给药方式、主要副作用以及需要紧急报告的症状。通常还需要验血和其他检查。','不同全身抗肿瘤治疗对身体的影响不同，因此团队需要确认治疗方案和剂量是否适合您。','肿瘤团队会复核诊断、治疗目标、检查结果、其他疾病和药物，并计划使用留置针、PICC、输液港、口服或其他给药方式。','并不是所有全身抗肿瘤治疗都是化疗。不同治疗的时间表、验血要求和副作用可能差别很大。',[
N('start-treatment','开始已商定的治疗','当所需检查结果合适且您准备继续时'),
N('repeat-checks','先重复验血或其他检查','如果团队需要更多信息才能决定是否治疗或是否调整剂量'),
N('review-plan','复查或调整治疗计划','如果健康状况、结果、您的偏好或治疗目标发生变化')
]),
treatment:S('治疗可能在肿瘤日间治疗单元、门诊或有时在家中进行。药物可以通过留置针、PICC、输液港、口服或其他方式给药。下一次治疗前通常会询问您的情况并复查血液结果。','治疗常按周期安排，让抗癌治疗与身体恢复时间取得平衡。','护士、药师和肿瘤团队会核对处方、剂量、血液结果、给药途径和副作用，并按需要给予止吐等支持药物。','您的治疗可能与另一位患者非常不同。如果更安全，团队可能推迟、减少或改变剂量。',[
N('continue-cycle','继续计划中的治疗周期','如果检查结果合适并可以继续'),
N('delay-or-adjust','推迟或调整治疗','如果血液结果、副作用、感染或其他健康问题需要改变计划'),
N('between-treatment-support','进入两次治疗之间的恢复和支持阶段','治疗后在家恢复并监测副作用时')
]),
support:S('两次治疗之间可能需要支持药物，以及关于副作用、饮食、活动和感染风险的建议。团队应给您紧急联系方式，并说明哪些症状必须立即报告。','有些副作用会在离开治疗单元后出现，血细胞计数也会在不同周期之间变化。','肿瘤团队会监测症状、血液结果和您对治疗的耐受情况，并可安排额外检查、支持治疗或提前复查。','请遵循您自己的肿瘤团队给出的体温界值和紧急症状建议。如果被告知某种症状需要紧急联系，不要等到常规预约。',[
N('next-treatment','返回接受下一次计划治疗','如果恢复充分且治疗前检查允许继续'),
N('supportive-review','接受额外支持或复查','如果副作用、结果、营养、疼痛或其他问题需要治疗或帮助'),
N('treatment-review','复查整体治疗计划','当肿瘤团队需要评估疗效、副作用或决定继续、调整或结束治疗时')
])}
};